<template>
  <b-row
    style="height: 100%"
    class="p-3"
  >
    <b-col cols="12">
      <span class="title">{{ $tc('configuration.sections.roles', 2) }}</span>
    </b-col>
    <b-col class="mt-2 tab-scroll-content without-footer association-table pl-0 pr-2 mx-2">
      <div class="d-flex mb-1 header-row">
        <div class="d-flex">
          <div class="fixed-column">
            <vt-input
              v-model="filter"
              class="form-control-sm"
              :placeholder="$t('configuration.modal.filterRoles')"
            />
          </div>
          <div
            v-for="(laboratory, index) in laboratories"
            :key="index"
            class="check-column d-flex align-items-center"
          >
            <span
              v-tooltip="laboratory.labName"
              class="pl-2"
            >{{ laboratory.labName }}</span>
          </div>
        </div>
      </div>
      <div
        v-for="(association, index) in filteredInternalRoleAssociations"
        :key="index"
        class="d-flex"
      >
        <div class="d-flex bottom-line">
          <div class="fixed-column">
            <span>{{ association[ASSOCIATION_TYPE.ROLE.key].name }}</span>
          </div>
          <div
            v-for="(roleLab, indexRoleLab) in association.laboratories"
            :key="indexRoleLab"
            class="check-column d-flex align-items-center"
            :class="index"
          >
            <b-form-checkbox
              v-model="roleLab.assigned"
              class="ml-2"
              @change="userappRoleChanged(roleLab, association)"
            />
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { ASSOCIATION_TYPE } from '@/api/resources/configuration/peopleManagement/AssociationTypes'
import UserappRoleConfigurationServices from '@/api/resources/configuration/peopleManagement/userapp/UserappRoleConfigurationServices'
import { TextNormalization } from '@/shared/util/text-normalization'

export default {
    name: 'UserappRoles',
    props: {
        laboratories: { type: Array },
        userappRoles: { type: Array },
        userappId: { type: Number }
    },
    data() {
        return {
            filter: ''
        }
    },
    computed: {
        filteredInternalRoleAssociations() {
            return this.userappRoles.filter(association => {
                return TextNormalization.normalizedContains(
                    this.filter,
                    association[this.ASSOCIATION_TYPE.ROLE.key].name
                )
            })
        },
        ASSOCIATION_TYPE() {
            return ASSOCIATION_TYPE
        }
    },
    methods: {
        async createUserappRole(lab, association) {
            const userappRoleCreateRequest = {
                userappId: this.userappId,
                roleId: association.role.id,
                laboratoryId: lab.labId
            }
            const [err, response] = await this.toCall(UserappRoleConfigurationServices.createUserappRole(userappRoleCreateRequest))
            if (err) {
                lab.assigned = false
                this.showErrorModalGlobal()
                return err
            }
            lab.assigned = true
            lab.userappRoleId = response.id
        },
        async deleteUserappRole(lab) {
            const [err] = await this.toCall(UserappRoleConfigurationServices.deleteUserappRole(lab.userappRoleId))
            if (err) {
                lab.assigned = true
                this.showErrorModalGlobal()
                return err
            }
            lab.assigned = false
        },
        async allLabsUserappRolesChanged(allLabs, association) {
            this.updateLoading(true)
            const allRolesLabs = association.laboratories.filter(lab => !lab.all && allLabs.assigned !== lab.assigned)
            let promisesResult = []
            let err = null
            for (let i = 0; i < allRolesLabs.length; i++) {
                const lab = allRolesLabs[i]
                if (!lab.assigned) {
                    promisesResult = await this.toCall(this.createUserappRole(lab, association))
                } else {
                    promisesResult = await this.toCall(this.deleteUserappRole(lab, association))
                }
            }
            err = promisesResult[0]
            this.updateLoading(false)
            return [err, allRolesLabs]
        },
        async userappRoleChanged(lab, association) {
            let err = null
            let allRolesLabs = []
            if (lab.all) {
                [err, allRolesLabs] = await this.allLabsUserappRolesChanged(lab, association)
            } else {
                if (lab.assigned) {
                    err = await this.createUserappRole(lab, association)
                } else err = await this.deleteUserappRole(lab, association)
            }
            if (!err) {
                if (lab.all) {
                    if (lab.assigned) {
                        const rolesDeleted = allRolesLabs.filter(rolLab => rolLab.assigned).length
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappRoleCreated', rolesDeleted, { userappRoles: rolesDeleted }))
                    } else {
                        const rolesCreated = allRolesLabs.filter(rolLab => !rolLab.assigned).length
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappRoleDeleted', rolesCreated, { userappRoles: rolesCreated }))
                    }
                } else {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappRoleCreated', 1))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappRoleDeleted', 1))
                    }
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
